import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VerticalSlider from './VerticalSlider';
import ClientProvider from './client';
export default createDemo(import.meta.url, VerticalSlider, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/vertical/VerticalSlider.tsx",
    "fileName": "VerticalSlider.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Stack from '@mui/material/Stack';\nimport Slider from '@mui/material/Slider';\n\nexport default function VerticalSlider() {\n  return (\n    <Stack sx={{ height: 300 }} spacing={1} direction=\"row\">\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Slider\n        aria-label=\"Temperature\"\n        orientation=\"vertical\"\n        getAriaValueText={getAriaValueText}\n        valueLabelDisplay=\"auto\"\n        defaultValue={30}\n      />\n      <Slider\n        aria-label=\"Temperature\"\n        orientation=\"vertical\"\n        defaultValue={30}\n        valueLabelDisplay=\"auto\"\n        disabled\n      />\n      <Slider\n        getAriaLabel={() => 'Temperature'}\n        orientation=\"vertical\"\n        getAriaValueText={getAriaValueText}\n        defaultValue={[20, 37]}\n        valueLabelDisplay=\"auto\"\n        marks={marks}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n\nfunction getAriaValueText(value: number) {\n  return `${value}°C`;\n}\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 54,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Stack from '@mui/material/Stack';\nimport Slider from '@mui/material/Slider';\n\nexport default function VerticalSlider() {\n  return (\n    <Stack sx={{ height: 300 }} spacing={1} direction=\"row\">\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Slider\n        aria-label=\"Temperature\"\n        orientation=\"vertical\"\n        getAriaValueText={getAriaValueText}\n        valueLabelDisplay=\"auto\"\n        defaultValue={30}\n      />\n      <Slider\n        aria-label=\"Temperature\"\n        orientation=\"vertical\"\n        defaultValue={30}\n        valueLabelDisplay=\"auto\"\n        disabled\n      />\n      <Slider\n        getAriaLabel={() => 'Temperature'}\n        orientation=\"vertical\"\n        getAriaValueText={getAriaValueText}\n        defaultValue={[20, 37]}\n        valueLabelDisplay=\"auto\"\n        marks={marks}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n\nfunction getAriaValueText(value: number) {\n  return `${value}°C`;\n}\n\nconst marks = [\n  {\n    value: 0,\n    label: '0°C',\n  },\n  {\n    value: 20,\n    label: '20°C',\n  },\n  {\n    value: 37,\n    label: '37°C',\n  },\n  {\n    value: 100,\n    label: '100°C',\n  },\n];\n"
      ]
    ],
    "totalLines": 54,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Stack",
      "@mui/material/Slider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
